module.exports = __webpack_public_path__ + "img/task.e5d6d114.png";